import { EyeClosedIcon, EyeIcon } from "lucide-react";
import React, { useEffect, useState } from "react";

function PasswordPinModal({ open, onClose, onSubmit }) {
  const [mode, setMode] = useState("password");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [newPin, setNewPin] = useState("");
  const [confirmNewPin, setConfirmNewPin] = useState("");
  const [viewIconClicked, setViewIconClicked] = useState({});

  useEffect(() => {
    if (!open) setMode("password");
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div onClick={onClose} className="absolute inset-0 bg-black/50" />

      {/* Modal */}
      <div className="relative z-10 w-[90%] max-w-md rounded-2xl bg-white p-6 shadow-xl">
        {/* Header */}
        <h2 className="text-xl font-semibold text-center mb-4">
          Set Security Method
        </h2>

        {/* Tabs */}
        <div className="mb-6 flex rounded-xl border border-blue-600 overflow-hidden">
          <button
            onClick={() => setMode("password")}
            className={`flex-1 py-2.5 text-sm font-semibold transition
      ${
        mode === "password"
          ? "bg-blue-600 text-white"
          : "bg-white text-blue-600 hover:bg-blue-50"
      }
    `}
          >
            Password
          </button>

          <button
            onClick={() => setMode("pin")}
            className={`flex-1 py-2.5 text-sm font-semibold transition
      ${
        mode === "pin"
          ? "bg-blue-600 text-white"
          : "bg-white text-blue-600 hover:bg-blue-50"
      }
    `}
          >
            PIN
          </button>
        </div>

        {/* Fields */}
        {mode === "password" ? (
          <div className="space-y-4">
            <div className="relative">
              <input
                value={newPassword}
                type={viewIconClicked[0] ? "text" : "password"}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter password"
                className="w-full rounded-xl border px-4 py-2 outline-none focus:border-blue-600"
              />

              <button
                onClick={() =>
                  setViewIconClicked((prev) => ({ ...prev, 0: !prev[0] }))
                }
                className="absolute p-2 top-0 text-gray-300 right-2"
              >
                {viewIconClicked[0] ? <EyeClosedIcon /> : <EyeIcon />}
              </button>
            </div>
            <div className="relative">
              <input
                value={confirmNewPassword}
                type={viewIconClicked[1] ? "text" : "password"}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                placeholder="Confirm password"
                className="w-full rounded-xl border px-4 py-2 outline-none focus:border-blue-600"
              />

              <button
                onClick={() =>
                  setViewIconClicked((prev) => ({ ...prev, 1: !prev[1] }))
                }
                className="absolute p-2 top-0 text-gray-300 right-2"
              >
                {viewIconClicked[1] ? <EyeClosedIcon /> : <EyeIcon />}
              </button>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="relative">
              <input
                value={newPin}
                type={viewIconClicked[2] ? "number" : "password"}
                onChange={(e) => setNewPin(e.target.value)}
                placeholder="Enter PIN"
                maxLength={6}
                inputMode="numeric"
                className="w-full rounded-xl border px-4 py-2 outline-none focus:border-blue-600"
              />

              <button
                onClick={() =>
                  setViewIconClicked((prev) => ({ ...prev, 2: !prev[2] }))
                }
                className="absolute p-2 z-20 top-0 text-gray-300 right-4"
              >
                {viewIconClicked[2] ? <EyeClosedIcon /> : <EyeIcon />}
              </button>
            </div>
            <div className="relative">
              <input
                value={confirmNewPin}
                type={viewIconClicked[3] ? "number" : "password"}
                onChange={(e) => setConfirmNewPin(e.target.value)}
                placeholder="Confirm PIN"
                maxLength={6}
                inputMode="numeric"
                className="w-full rounded-xl border px-4 py-2 outline-none focus:border-blue-600"
              />

              <button
                onClick={() =>
                  setViewIconClicked((prev) => ({ ...prev, 3: !prev[3] }))
                }
                className="absolute p-2 z-20 top-0 text-gray-300 right-4"
              >
                {viewIconClicked[3] ? <EyeClosedIcon /> : <EyeIcon />}
              </button>
            </div>
          </div>
        )}

        {/* Actions */}
        <button
          onClick={() =>
            onSubmit?.(
              mode,
              newPin,
              confirmNewPin,
              newPassword,
              confirmNewPassword,
            )
          }
          className="mt-6 w-full rounded-xl bg-blue-600 py-2.5 font-semibold text-white"
        >
          Continue
        </button>

        <button
          onClick={onClose}
          className="mt-3 w-full text-sm text-gray-500 hover:underline"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default PasswordPinModal;
